const BASE_URL_ACCOUNT_MOBILE = `${process.env.VUE_APP_API_URL_ACCOUNT}/v1`

// Employee
export const API_MOBILE = {
  RESET_PASSWORD: `${BASE_URL_ACCOUNT_MOBILE}/auth/change-password`,
  EMAIL_VERIFICATION: `${BASE_URL_ACCOUNT_MOBILE}/auth/verification`
}
